import React from "react";

import "./../../css/about.css";

export class AboutComponent extends React.Component {

    constructor(props) {
        super(props);
        this.disableContextMenu = this.disableContextMenu.bind(this);
    }

    componentDidMount() {
        // TODO
    }

    disableContextMenu(event) {
        event.preventDefault();
    }

    render() {
        return (
            <section id="about-component">
                <div className="header">About</div>
                <div className="content-box">
                    <div className="portrait" onContextMenu={this.disableContextMenu}><img src="assets/wilson-ng.jpg" alt="Wilson Ng" /></div>
                    <span>
                        Welcome! This is Wilson Ng! I am a photo-enthusiast based in San Francisco, Bay Area. I take great pride in producing my images. With every click of my shutter, I aim to create aesthetically pleasing photograph that freezes a beautiful moment in nature and I strive to give you only those I would hang in my own living room! Each image is carefully planned, shot and post-processed to attain the highest image quality standard that would truly shine in large prints.<br /><br />
                        This hobby has been my most enjoyable creative outlet. On rare occasions, it had even brought me some surprises! To name some, I am honored and lucky to have won awards from and/or got featured in <strong>Tamron USA</strong>, <strong>Outdoor Photographer Magazine</strong>, <strong>J-Weekly USA Newspaper</strong>, <strong>Pashadelic Landscape Photography</strong>, <strong>Popular Photography USA</strong>, <strong>Digital Photo Mag</strong>, <strong>OCWeekly Newsletter</strong>, <strong>Earth Shots</strong>, <strong>Bay Area Photography Contest 2014</strong>, and several Monthly and Photo-of-the-Day/Week awards.
                    </span>
                </div>
            </section>
        );
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Scroll/AboutComponent.js